
import { useMsal } from "@azure/msal-react";
import {
  Button,
  Checkbox, CircularProgress, Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, Divider, FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  TextField,
  Typography
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import { isAuthorized, rollen } from "../../utils/auth/authConfig";
import { getBetriebsereignisse } from "../betriebsereignisse/betriebsereignisseSlice";
import { exportSections } from "./exportConfig";
import {
  emptyAktiverMesspunkt, exportAktiveMesspunkte, getAktiveMesspunkte,
  resetExportColumn, selectAktiveMesspunkte, selectEditMode, selectExportColumns, selectMesspunkt,
  selectMesspunktLoading, selectNewMode, selectSelectedAktiverMesspunkt, selectSelectedUW, setColumnsDeselection,
  setColumnsSelection, setExportColumn, setNewMode, setSelectedAktiverMesspunkt, setSelectedUW,
  emptyGeraet, emptyMessstelle, emptyRouter,
  setGeraetDaten, setRouterDaten, setMessstelleDaten,
} from "./geraeteManagementSlice";
import { useStyles } from "./geraeteManagementStyles";
import { ExportColumns } from "./geraeteManagementTypes";
import { GeraetestatusAnhang } from "./GeraetestatusAnhang";
import { Messpunkt } from "./Messpunkt";
import { ButtonInteraktion } from "./ButtonInteraktion";


export default function GeraeteManagement(): ReactElement {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const rollenObj = rollen;


  useEffect(() => {
    dispatch(getAktiveMesspunkte());
    dispatch(getBetriebsereignisse())
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const [uwSelectInputValue, setUwSelectInputValue] = React.useState("");
  const [messpunktSelectInputValue, setMesspunktSelectInputValue] = React.useState("");
  const [openExportDialog, setOpenExportDialog] = React.useState(false);

  const selectedUW = useAppSelector(selectSelectedUW);
  const aktiveMesspunkte = useAppSelector(selectAktiveMesspunkte);
  const selectedAktiverMesspunkt = useAppSelector(selectSelectedAktiverMesspunkt);

  const editMode = useAppSelector(selectEditMode);
  const newMode = useAppSelector(selectNewMode);
  const exportColumnsSelection = useAppSelector(selectExportColumns);
  const messpunktLoading = useAppSelector(selectMesspunktLoading);

  function exportColumnsPrint(state: Array<string>, setState: (column: string) => { payload: string, type: string }, label: string, column: string, category: string) {
    return (
      <FormControlLabel
        control={<Checkbox data-cy="export-checkbox" id="checkboxExport" checked={state.includes(column)} onChange={() => dispatch(setState(column))} name={category + "-" + column} />}
        label={label}
      />
    )
  }
  function exportSectionPrint(label: string, category: string, columns: Array<ExportColumns>) {
    return (
      <Grid item md={4}>

        <FormControl data-cy="export-form-control" component="fieldset" className={classes.formControl}>
          <FormLabel className={classes.sectionLabelControl} color="secondary">{label}</FormLabel>
          <Grid container >
            <Grid item xs={5} >
              <Button
                data-cy="export-alles-auswaehlen-button"
                variant="contained"
                className={classes.exportSectionStyle}
                onClick={() => dispatch(setColumnsSelection(category))}>
                Alles auswählen
              </Button>
            </Grid>
            <Grid item xs={5}>
              <Button
                data-cy="export-auswahl-aufheben-button"
                variant="contained"
                className={classes.exportSectionStyle}
                onClick={() => dispatch(setColumnsDeselection(category))}>
                Auswahl aufheben
              </Button>
            </Grid>
          </Grid>
          <Divider className={classes.divider} />
          <FormGroup data-cy="export-form-group">
            {columns.map(e => exportColumnsPrint(exportColumnsSelection, setExportColumn, e.label, e.column, category))}
          </FormGroup>
        </FormControl>
      </Grid>)
  }

  function exportSelection() {
    return (
      <React.Fragment>
        <Button
          data-cy="header-export-button"
          variant="contained"
          onClick={() => setOpenExportDialog(true)}
          color="default"
          style={{ width: "225px" }}
          disabled={messpunktLoading}
        >
          Export
        </Button>

        <Dialog
          data-cy="export-dialog"
          open={openExportDialog}
          onClose={() => setOpenExportDialog(false)}
          maxWidth={"lg"}
          fullWidth={true}
        >
          <DialogTitle>Export Aktive Messpunkte</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {'Bitte wählen Sie die die zu exportierenden Informationen der aktiven Messpunkte'}
            </DialogContentText>
            <Grid data-cy="export-grid" container spacing={2}>
              {exportSections.map(e => exportSectionPrint(e.label, e.category, e.exportColumns))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              data-cy="abbrechen-dialog-button"
              color="secondary"
              variant="contained"
              onClick={cancelExportAktiverMesspunkt}
              className={classes.cancleDeleteButton}
            >
              Abbrechen
            </Button>
            <Button
              data-cy="exportieren-dialog-button"
              variant="contained"
              color="secondary"
              disabled={exportColumnsSelection.length == 0}
              onClick={confirmExportAktiverMesspunkt}
              style={{ minHeight: "36px" }}
            >
              {messpunktLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Exportieren"}

            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }


  const confirmExportAktiverMesspunkt = () => {
    dispatch(exportAktiveMesspunkte(exportColumnsSelection));
    setOpenExportDialog(false);
  }
  const cancelExportAktiverMesspunkt = () => {
    dispatch(resetExportColumn());
    setOpenExportDialog(false);
  }

  return (
    <Container data-cy="aktive-messpunkt-container" maxWidth={false} style={{ marginTop: "10px" }}>
      <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
        <Grid item md={3} />
        <Grid item md={6}>
          <Typography color="primary" variant="h5">
            Aktive Messpunkte Verwaltung
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Paper className={classes.paper} style={{ marginLeft: "10px", marginRight: "10px", width: "100%" }}>
          <Grid container spacing={2}>
            <Grid container item style={{ marginBottom: "20px", marginLeft: "16px" }}>
              <Grid item md={6} >
                <Typography color="primary" variant="h6" className={classes.typoH6Style} >
                  Messpunkt Auswahl
                </Typography>
              </Grid>
              <Grid item md={6} style={{ paddingRight: "20px", textAlign: "right" }}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    data-cy="header-neuer-Messpunkt-button"
                    variant="contained"
                    color="secondary"
                    disabled={editMode || newMode}
                    onClick={() => (
                      dispatch(setNewMode(true)),
                      dispatch(setSelectedAktiverMesspunkt(emptyAktiverMesspunkt)),
                      dispatch(setMessstelleDaten(emptyMessstelle)),
                      dispatch(setGeraetDaten(emptyGeraet)),
                      dispatch(setRouterDaten(emptyRouter)),
                      dispatch(setSelectedUW(""))

                    )}
                    style={{ marginRight: "10px", width: "225px" }}
                  >
                    Neuer Messpunkt
                  </Button>
                  : ""}
                {exportSelection()}
              </Grid>
              <Grid item container spacing={2} md={12} style={{ paddingTop: "10px" }} >
                <Grid item md={6}>
                  <FormControl
                    className={classes.formControlAutoCompleteAuswahl}
                  >
                    <Autocomplete
                      data-cy="select-uw-autocomplete"
                      id="select-uw"
                      value={selectedUW}
                      noOptionsText={<React.Fragment>
                        {messpunktLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Umspannwerke"}
                      </React.Fragment>}
                      onChange={(event, newValue) => {
                        dispatch(setSelectedUW(newValue ? newValue : ""));
                        setMesspunktSelectInputValue("");
                        dispatch(selectMesspunkt(emptyAktiverMesspunkt));
                      }}
                      inputValue={uwSelectInputValue}
                      onInputChange={(event, newInputValue) => setUwSelectInputValue(newInputValue)}
                      options={[...new Set(aktiveMesspunkte.map((e) => e.umspannwerk).sort())]}
                      getOptionLabel={(option) => (option ? option : "")}
                      renderInput={(params) => <TextField {...params}
                        label="Umspannwerk"
                        variant="outlined"
                      />}
                      disabled={newMode}
                      className={classes.selectEmpty}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl
                    className={classes.formControlAutoCompleteAuswahl}
                  >
                    <Autocomplete
                      data-cy="select-messpunkt-autocomplete"
                      id="select-messpunkt"
                      value={selectedAktiverMesspunkt}
                      noOptionsText={<React.Fragment>
                        {messpunktLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine aktiven Messpunkte"}</React.Fragment>}
                      onChange={(event, newValue) => {
                        const a = aktiveMesspunkte.filter(e => e.name === newValue?.name);
                        dispatch(selectMesspunkt(a.length > 0 ? a[0] : emptyAktiverMesspunkt));
                      }
                      }
                      inputValue={messpunktSelectInputValue}
                      onInputChange={(event, newInputValue) => {
                        setMesspunktSelectInputValue(newInputValue);
                      }}
                      options={aktiveMesspunkte.filter((e) => e.umspannwerk === selectedUW)}
                      getOptionLabel={(option) => (option.name != "" ? (option.schaltfeld + " (" + option.name + ")") : "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Messpunkt"
                          variant="outlined"
                        />
                      )}
                      disabled={newMode}
                      className={classes.selectEmpty}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        {(newMode || (selectedAktiverMesspunkt != emptyAktiverMesspunkt) ?
          <React.Fragment>
            <Paper className={classes.paper} style={{ marginLeft: "10px", marginRight: "10px", width: "100%" }}>
              <Grid container spacing={2}>
                <Grid container item style={{ marginBottom: "20px" }}>
                  <Grid item md={6} >
                    <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"} style={{ marginLeft: "16px" }}>
                      {newMode ? "Neuer aktiver Messpunkt anlegen" : "Zugeordnete Geräte für den aktiven Messpunkt: " + selectedAktiverMesspunkt.name + " (" + selectedAktiverMesspunkt.schaltfeld + ")"}
                    </Typography>
                  </Grid>
                  <ButtonInteraktion></ButtonInteraktion>
                  <Messpunkt></Messpunkt>
                  <GeraetestatusAnhang></GeraetestatusAnhang>
                </Grid>
              </Grid>
            </Paper>
          </React.Fragment>
          : "")}
      </Grid>
    </Container >
  );
}
